<ul class="nav nav-tabs">
        <li class="nav-item pe-2">
            <a class="nav-link active" aria-current="page">Buscar agencia</a>
        </li>
      
    </ul>
    <div class="row">
        <div class="col-12 mt-4">
            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login">
                <div class="form-control p-0 position-relative">
                    <input type="search" formControlName="search" class="w-100 border-secondary" placeholder="Buscar agencia por nombre o por correo electrónico">
                    <input type="image" src="../assets/images/body/icons/search-icon.svg" class="position-absolute search-icon" style="border: 0px; padding: 0px;"  alt="Buscar" />
                </div>
            </form>
            
        </div>
        <!-- <div class="col-12 mt-4 d-flex">
            <div class="text-secondary rounded-pill border border-2 me-3 border-secondary btn-md btn-outline">
                Destino
            </div>
        </div> -->
    </div>
    
    <div class="d-flex flex-lg-row flex-column justify-content-between mt-5">
        <h4 *ngIf="cantidad !== 0" class="title-bg ">Solicitudes pendientes</h4>
        <a *ngIf="cantidad !== 0" class="btn btn-lg rounded-pill border-2 text-center btn-reservar align-self-center mt-lg-0 mt-4 btn-outline-secondary" style="cursor: pointer;" (click)="aprobarAll()">Aprobar todos</a>
    </div>
    <div class="mt-4">
        <div *ngFor="let item of listAgencias" class="pasajero-admin bg-light d-md-flex flex-wrap flex-lg-row align-items-center justify-content-between p-3 mb-3">
            <div class="d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="pe-3" width="50" height="50" viewBox="0 0 40 40"><g transform="translate(-120 -306)"><path d="M20,0h0A20,20,0,0,1,40,20v0A20,20,0,0,1,20,40H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z" transform="translate(120 306)" class="fondo" fill="#00008b"/><path d="M16.789,16.789a5.394,5.394,0,1,0-5.394-5.394A5.393,5.393,0,0,0,16.789,16.789Zm0,2.7C13.188,19.486,6,21.293,6,24.88v2.7H27.577v-2.7C27.577,21.293,20.389,19.486,16.789,19.486Z" transform="translate(123.211 309.211)" class="icono" fill="#fff"/></g></svg>
                <h5 class="mb-0 text-center">{{item.nombre_agencia}}</h5>
            </div>
            <div class="mt-4 mt-lg-0 d-flex">
                <a [routerLink]="['/','admin', 'perfil-pendiente',item.id]"  class="me-2 mb-0 mb-lg-0 btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Ver perfil</a>
                               
                <a style="cursor: pointer;" (click)="aprobar(item.id)" class=" d-md-none me-2  text-white text-center btn-reservar align-self-center"><img src="../assets/images/body/icons/aceptar-agencia.svg" alt=""></a>
                <a style="cursor: pointer;" (click)="eliminar(item.id)" class=" d-md-none text-white text-center btn-reservar align-self-center"><img src="../assets/images/body/icons/cancelar-agencia.svg" alt=""></a>
                
                <a style="cursor: pointer;" class="d-none d-md-flex me-2 mb-3 mb-lg-0 btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center" (click)="aprobar(item.id)">Aprobar</a>
                <a style="cursor: pointer;" class="d-none d-md-flex mb-lg-0 btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center" (click)="eliminar(item.id)">Dar de baja</a>
            </div>
        </div>        
        
    </div>
    

